// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getPartDetails} from '../../shared/repositories';
import {updateComponentToAdd} from './component-to-add';

export const readPartDetails = partNumber =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const partDetails = await getPartDetails(partNumber);

            updateComponentToAdd('partNumber', partDetails.partNumber)(dispatch);
            updateComponentToAdd('description', partDetails.partDescription)(dispatch);

            dispatch({
                isVisible: true,
                type: actions.UPDATE_PRODUCT_DETAILS_SHOW_ADD_COMPONENT_ROW
            });

        } catch (error) {

            updateComponentToAdd('serialNumber', '')(dispatch);
            updateComponentToAdd('code', '')(dispatch);

            dispatch({
                isVisible: false,
                type: actions.UPDATE_PRODUCT_DETAILS_SHOW_ADD_COMPONENT_ROW
            });

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/read-part-details.js